import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-loadForecast",
  "use": "icon-loadForecast-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-loadForecast\"><path d=\"M0 0h18v18H0Z\" style=\"fill:none\" /><path d=\"M2.882 13.087V6.204a3.427 3.427 0 0 1 3.441-3.441 3.535 3.535 0 0 1 3.441 3.059v4.589h4.589V3.146a.383.383 0 1 1 .765 0v7.265a3.059 3.059 0 1 1-6.118 0V5.822H3.646v7.265a.383.383 0 0 1-.765 0Zm13.383 1.147H1.734a.383.383 0 1 0 0 .765h14.53a.383.383 0 1 0 0-.765Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol